import { FC } from 'react';
import { useEffect } from 'react';
import Script from 'next/script';
import $ from 'jquery';
import styles from './LitresWidget.module.scss';

interface ILitresWidget {
  bookTitle: string;
  authorName?: string;
  lfrom: number;
}

const LitresWidget: FC<ILitresWidget> = ({ bookTitle, authorName, lfrom }) => {
  let fix = true;
  useEffect(() => {
    fix = !fix;
    if (fix) return;
    <Script src="//www.litres.ru/static/widgets/buy_widget/js/widget.js" strategy="lazyOnload" />;

    $.get(
      'https://www.litres.ru/ref_widget_art_alltypes/',
      {
        q: bookTitle,
        q_author: authorName,
        lfrom: lfrom,
      },
      function (data: any) {
        $('#widget').append(data);
      }
    );
  }, []);

  return (
    <div className={styles.litresWidget}>
      <h2 className={styles.litresWidget__title}>Полная версия</h2>
      <div id="widget"></div>
    </div>
  );
};

export default LitresWidget;
